const baseSize = 75
// 设置 rem 函数
function setRem() {
  let clientWidth = document.documentElement.clientWidth
  // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。>414?414 :document.documentElement.clientWidth
  const scale = clientWidth / 1920
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem()
}






// WEBPACK FOOTER //
// ./src/assets/js/rem.js